import { Trans } from '@lingui/react/macro';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserNotificationsSection } from '../components/user-notifications-section.js';
import { WorkspaceNav } from '../components/workspace-nav.js';
import { useDocumentTitle } from '../lib/document-title.js';
import { meQuery } from '../lib/queries.js';

// /settings/notifications — the founder's OWN notification settings
// (spec 1151ae36), beside /settings/billing, /settings/team and
// /settings/workspace.
//
// NO ROLE GATE, unlike the team page which bounces non-admins. These are
// personal settings: every member has quiet hours of their own, and
// gating them would mean a member could never stop mag pinging them at
// 3am. Nothing here reads or writes another user's row — the api scopes
// every preference to the session's user.

export const Route = createFileRoute('/settings/notifications')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    return { me };
  },
  loader: ({ context }) => context as { me: { id: string; email: string } },
  component: UserNotificationsPage,
});

function UserNotificationsPage() {
  useDocumentTitle(['notifications']);

  return (
    <main className="min-h-screen bg-[var(--cream)]">
      <WorkspaceNav />
      <section className="mx-auto max-w-[900px] px-4 pb-16 pt-8 sm:px-7">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--plum)]">
          {'↘'} <Trans>your notifications</Trans>
        </p>
        <h1 className="mt-2 font-display text-[28px] font-black leading-[1.05] tracking-[-0.04em] sm:text-[34px]">
          <Trans>when to reach you.</Trans>
        </h1>
        <div className="mt-6">
          <UserNotificationsSection />
        </div>
      </section>
    </main>
  );
}
